// Copyright 2026 Granite (granite.md). All rights reserved.
// Proprietary and confidential. Unauthorized copying is prohibited.
/**
 * Words the components show by themselves (the dialog's close button), in the app's language.
 * The app sets them from its message catalog when it starts and when the language changes.
 */
export const uiText = { close: "Close" };
export function setUiText(text) {
    Object.assign(uiText, text);
}
//# sourceMappingURL=text.js.map